import axios from "axios";
import Config from "../../../config/index";

import {
  CREATE_FG_FAILURE,
  CREATE_FG_REQUEST,
  CREATE_FG_SUCCESS,
  CREATE_PASSPORT_FAILURE,
  CREATE_PASSPORT_REQUEST,
  CREATE_PASSPORT_SUCCESS,
  CREATE_RM_FAILURE,
  CREATE_RM_REQUEST,
  CREATE_RM_SUCCESS,
  EDIT_FG_FAILURE,
  EDIT_FG_REQUEST,
  EDIT_FG_SUCCESS,
  EDIT_PASSPORT_FAILURE,
  EDIT_PASSPORT_REQUEST,
  EDIT_PASSPORT_SUCCESS,
  EDIT_RM_FAILURE,
  EDIT_RM_REQUEST,
  EDIT_RM_SUCCESS,
  GET_DELETE_FG_FAILURE,
  GET_DELETE_FG_REQUEST,
  GET_DELETE_FG_SUCCESS,
  GET_DELETE_PASSPORT_FAILURE,
  GET_DELETE_PASSPORT_REQUEST,
  GET_DELETE_PASSPORT_SUCCESS,
  GET_DELETE_RM_FAILURE,
  GET_DELETE_RM_REQUEST,
  GET_DELETE_RM_SUCCESS,
  GET_DPPIDS_FAILURE,
  GET_DPPIDS_REQUEST,
  GET_DPPIDS_SUCCESS,
  GET_FG_OPERATION_FAILURE,
  GET_FG_OPERATION_REQUEST,
  GET_FG_OPERATION_SUCCESS,
  GET_INDUSTRY_TYPE_FAILURE,
  GET_INDUSTRY_TYPE_REQUEST,
  GET_INDUSTRY_TYPE_SUCCESS,
  GET_PASSPORT_DPPCODE_FAILURE,
  GET_PASSPORT_DPPCODE_REQUEST,
  GET_PASSPORT_DPPCODE_SUCCESS,
  GET_PASSPORT_FAILURE,
  GET_PASSPORT_REQUEST,
  GET_PASSPORT_SUCCESS,
  GET_RM_TRACE_FAILURE,
  GET_RM_TRACE_REQUEST,
  GET_RM_TRACE_SUCCESS,
  GET_SUPPLIER_ID_FAILURE,
  GET_SUPPLIER_ID_REQUEST,
  GET_SUPPLIER_ID_SUCCESS,
  GET_USERS_FOR_PRODUCTION_FAILURE,
  GET_USERS_FOR_PRODUCTION_REQUEST,
  GET_USERS_FOR_PRODUCTION_SUCCESS,
  CREATE_PRODUCT_SPEC_REQUEST,
  CREATE_PRODUCT_SPEC_SUCCESS,
  CREATE_PRODUCT_SPEC_FAILURE,
  GET_PRODUCT_SPECIFICATION_FAILURE,
  GET_PRODUCT_SPECIFICATION_REQUEST,
  GET_PRODUCT_SPECIFICATION_SUCCESS,
  UPLOADCSV_PRODUCT_PASSPORT_CHILD_REQUEST,
  UPLOADCSV_PRODUCT_PASSPORT_CHILD_SUCCESS,
  UPLOADCSV_PRODUCT_PASSPORT_CHILD_FAILURE,
} from "./passPortTypes";

let baseUrl = Config.baseUrl;

let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getPassPortRequest = () => {
  return {
    type: GET_PASSPORT_REQUEST,
  };
};

const getPassPortSuccess = (payload) => {
  return {
    type: GET_PASSPORT_SUCCESS,
    payload: payload,
  };
};

const getPassPortFailure = (error) => {
  return {
    type: GET_PASSPORT_FAILURE,
    payload: error,
  };
};

const getPassPort = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getPassPortRequest());

    let url;

    // If dppId exists → fetch passport for that specific DPP
    if (dppId) {
      url = `${baseUrl}/dpp/v1/product_passport/get_one?dppId=${dppId}`;
    } else {
      // Otherwise → fetch all passports
      url = `${baseUrl}/dpp/v1/product_passport/get_all_view`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPassPortSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPassPortFailure(err.message));
      });
  };
};

const getUsersForFGRequest = () => {
  return {
    type: GET_USERS_FOR_PRODUCTION_REQUEST,
  };
};

const getUsersForFGSuccess = (payload) => {
  return {
    type: GET_USERS_FOR_PRODUCTION_SUCCESS,
    payload: payload,
  };
};

const getUsersForFGFailure = (error) => {
  return {
    type: GET_USERS_FOR_PRODUCTION_FAILURE,
    payload: error,
  };
};

const getUsersForFG = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getUsersForFGRequest());
    let url = `${baseUrl}/dpp/product_passport/get_all_user_id`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUsersForFGSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getUsersForFGFailure(err.message));
      });
  };
};

const getDppIdsRequest = () => {
  return {
    type: GET_DPPIDS_REQUEST,
  };
};

const getDppIdsSuccess = (payload) => {
  return {
    type: GET_DPPIDS_SUCCESS,
    payload: payload,
  };
};

const getDppIdsFailure = (error) => {
  return {
    type: GET_DPPIDS_FAILURE,
    payload: error,
  };
};

const getDppIds = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDppIdsRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/get_all_id`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response)
        dispatch(getDppIdsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDppIdsFailure(err.message));
      });
  };
};

const getIndustryTypeRequest = () => {
  return {
    type: GET_INDUSTRY_TYPE_REQUEST,
  };
};

const getIndustryTypeSuccess = (payload) => {
  return {
    type: GET_INDUSTRY_TYPE_SUCCESS,
    payload: payload,
  };
};

const getIndustryTypeFailure = (error) => {
  return {
    type: GET_INDUSTRY_TYPE_FAILURE,
    payload: error,
  };
};

const getIndustryType = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getIndustryTypeRequest());
    let url = `${baseUrl}/dpp/industry_master/get`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response)
        dispatch(getIndustryTypeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getIndustryTypeFailure(err.message));
      });
  };
};

const getSupplierTypeRequest = () => {
  return {
    type: GET_SUPPLIER_ID_REQUEST,
  };
};

const getSupplierTypeSuccess = (payload) => {
  return {
    type: GET_SUPPLIER_ID_SUCCESS,
    payload: payload,
  };
};

const getSupplierTypeFailure = (error) => {
  return {
    type: GET_SUPPLIER_ID_FAILURE,
    payload: error,
  };
};

const getSupplierType = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSupplierTypeRequest());
    let url = `${baseUrl}/dpp/supplier_information/get`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response)
        dispatch(getSupplierTypeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSupplierTypeFailure(err.message));
      });
  };
};
const getViewDataByDppIdRequest = () => {
  return {
    type: GET_PASSPORT_DPPCODE_REQUEST,
  };
};

const getViewDataByDppIdSuccess = (payload) => {
  return {
    type: GET_PASSPORT_DPPCODE_SUCCESS,
    payload: payload,
  };
};

const getViewDataByDppIdFailure = (error) => {
  return {
    type: GET_PASSPORT_DPPCODE_FAILURE,
    payload: error,
  };
};

const getViewDataByDppId = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getViewDataByDppIdRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/get_childs?dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getViewDataByDppIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getViewDataByDppIdFailure(err.message));
      });
  };
};

const getRmTraceabilityRequest = () => {
  return {
    type: GET_RM_TRACE_REQUEST,
  };
};

const getRmTraceabilitySuccess = (payload) => {
  return {
    type: GET_RM_TRACE_SUCCESS,
    payload: payload,
  };
};

const getRmTraceabilityFailure = (error) => {
  return {
    type: GET_RM_TRACE_FAILURE,
    payload: error,
  };
};

const getRmTraceability = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getRmTraceabilityRequest());

    let url;

    // If dppId is provided → fetch data based on specific DPP
    if (dppId) {
      url = `${baseUrl}/dpp/get_rmtracebility_bydpp?dppId=${dppId}`;
    } else {
      // Otherwise → fetch all RM traceability data
      url = `${baseUrl}/dpp/get_rmtracebility`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRmTraceabilitySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRmTraceabilityFailure(err.message));
      });
  };
};

const getFgOperationRequest = () => {
  return {
    type: GET_FG_OPERATION_REQUEST,
  };
};

const getFgOperationSuccess = (payload) => {
  return {
    type: GET_FG_OPERATION_SUCCESS,
    payload: payload,
  };
};

const getFgOperationFailure = (error) => {
  return {
    type: GET_FG_OPERATION_FAILURE,
    payload: error,
  };
};

const getFgOperation = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getFgOperationRequest());

    let url;

    // If dppId is provided → call endpoint with dppId filter
    if (dppId) {
      url = `${baseUrl}/dpp/get_fg_operation_bydpp?dppId=${dppId}`;
    } else {
      // If no dppId → fetch all FG operation data
      url = `${baseUrl}/dpp/get_fg_operation`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgOperationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFgOperationFailure(err.message));
      });
  };
};

// const getDocumentTypeWithPaginationRequest = () => {
//   return {
//     type: GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST,
//   };
// };

// const getDocumentTypeWithPaginationSuccess = (payload) => {
//   return {
//     type: GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS,
//     payload: payload,
//   };
// };

// const getDocumentTypeWithPaginationFailure = (error) => {
//   return {
//     type: GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE,
//     payload: error,
//   };
// };

// const getDocumentTypeWithPagination = (
//   pageNo,
//   rowsPerPage,
//   search,
//   jwtToken
// ) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };
//   return (dispatch) => {
//     dispatch(getDocumentTypeWithPaginationRequest());
//     let url = `${baseUrl}/document?page_number=${
//       pageNo + 1
//     }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getDocumentTypeWithPaginationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getDocumentTypeWithPaginationFailure(err.message));
//       });
//   };
// };

// const createDocumentTypeRequest = () => {
//   return {
//     type: CREATE_DOCUMENT_TYPE_REQUEST,
//   };
// };

// const createDocumentTypeSuccess = (payload) => {
//   return {
//     type: CREATE_DOCUMENT_TYPE_SUCCESS,
//     payload: payload,
//   };
// };

// const createDocumentTypeFailure = (error) => {
//   return {
//     type: CREATE_DOCUMENT_TYPE_FAILURE,
//     payload: error,
//   };
// };

// const createDocumentType = (payload, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };
//   return (dispatch) => {
//     dispatch(createDocumentTypeRequest());
//     let url = `${baseUrl}/document`;
//     return axios
//       .post(url, payload, headers)
//       .then((response) => {
//         dispatch(createDocumentTypeSuccess(response.data));
//         return { status: true, data: response.data };
//       })
//       .catch((err) => {
//         dispatch(createDocumentTypeFailure(err.response));
//         return { status: false, data: err.response };
//       });
//   };
// };

const deletePassportRequest = () => {
  return {
    type: GET_DELETE_PASSPORT_REQUEST,
  };
};

const deletePassportSuccess = (payload) => {
  return {
    type: GET_DELETE_PASSPORT_SUCCESS,
    payload: payload,
  };
};

const deletePassportFaliure = (error) => {
  return {
    type: GET_DELETE_PASSPORT_FAILURE,
    payload: error,
  };
};

const deletePassport = (dppId, userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deletePassportRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/delete?dppId=${dppId}&userId=${userId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deletePassportSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deletePassportFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteRmRequest = () => {
  return {
    type: GET_DELETE_RM_REQUEST,
  };
};

const deleteRmSuccess = (payload) => {
  return {
    type: GET_DELETE_RM_SUCCESS,
    payload: payload,
  };
};

const deleteRmFaliure = (error) => {
  return {
    type: GET_DELETE_RM_FAILURE,
    payload: error,
  };
};

const deleteRm = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteRmRequest());
    let url = `${baseUrl}/dpp/delete_rmtracebility?rmTraceId=${dppId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteRmSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteRmFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deletefGRequest = () => {
  return {
    type: GET_DELETE_FG_REQUEST,
  };
};

const deletefGSuccess = (payload) => {
  return {
    type: GET_DELETE_FG_SUCCESS,
    payload: payload,
  };
};

const deletefGFaliure = (error) => {
  return {
    type: GET_DELETE_FG_FAILURE,
    payload: error,
  };
};

const deletefG = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deletefGRequest());
    let url = `${baseUrl}/dpp/delete_fg_operation?fgOpId=${dppId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deletefGSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deletefGFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createPassPortRequest = () => {
  return {
    type: CREATE_PASSPORT_REQUEST,
  };
};

const createPassPortSuccess = (payload) => {
  return {
    type: CREATE_PASSPORT_SUCCESS,
    payload: payload,
  };
};

const createPassPortFailure = (error) => {
  return {
    type: CREATE_PASSPORT_FAILURE,
    payload: error,
  };
};

const createPassPort = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPassPortRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPassPortSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPassPortFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createFGRequest = () => {
  return {
    type: CREATE_FG_REQUEST,
  };
};

const createFGSuccess = (payload) => {
  return {
    type: CREATE_FG_SUCCESS,
    payload: payload,
  };
};

const createFGFailure = (error) => {
  return {
    type: CREATE_FG_FAILURE,
    payload: error,
  };
};

const createFG = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createFGRequest());
    let url = `${baseUrl}/dpp/create_fg_operation`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createFGSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createFGFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createRmRequest = () => {
  return {
    type: CREATE_RM_REQUEST,
  };
};

const createRmSuccess = (payload) => {
  return {
    type: CREATE_RM_SUCCESS,
    payload: payload,
  };
};

const createRmFailure = (error) => {
  return {
    type: CREATE_RM_FAILURE,
    payload: error,
  };
};

const createRm = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createRmRequest());
    let url = `${baseUrl}/dpp/create_rmtracebility`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createRmSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createRmFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editPassportRequest = () => {
  return {
    type: EDIT_PASSPORT_REQUEST,
  };
};

const editPassportSuccess = (payload) => {
  return {
    type: EDIT_PASSPORT_SUCCESS,
    payload: payload,
  };
};

const editPassportFailure = (error) => {
  return {
    type: EDIT_PASSPORT_FAILURE,
    payload: error,
  };
};

const editPassport = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editPassportRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/update`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editPassportSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editPassportFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editRMRequest = () => {
  return {
    type: EDIT_RM_REQUEST,
  };
};

const editRMSuccess = (payload) => {
  return {
    type: EDIT_RM_SUCCESS,
    payload: payload,
  };
};

const editRMFailure = (error) => {
  return {
    type: EDIT_RM_FAILURE,
    payload: error,
  };
};

const editRM = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editRMRequest());
    let url = `${baseUrl}/dpp/update_rmtracebility`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editRMSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editRMFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editFgRequest = () => {
  return {
    type: EDIT_FG_REQUEST,
  };
};

const editFgSuccess = (payload) => {
  return {
    type: EDIT_FG_SUCCESS,
    payload: payload,
  };
};

const editFgFailure = (error) => {
  return {
    type: EDIT_FG_FAILURE,
    payload: error,
  };
};

const editFg = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editFgRequest());
    let url = `${baseUrl}/dpp/update_fg_operation`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editFgSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editFgFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getManufacturerDetailsRequest = () => {
  return {
    type: "GET_MANUFACTURER_DETAILS_REQUEST",
  };
};

const getManufacturerDetailsSuccess = (payload) => {
  return {
    type: "GET_MANUFACTURER_DETAILS_SUCCESS",
    payload: payload,
  };
};

const getManufacturerDetailsFailure = (error) => {
  return {
    type: "GET_MANUFACTURER_DETAILS_FAILURE",
    payload: error,
  };
};

const getManufacturerDetails = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getManufacturerDetailsRequest());
    let url = `${baseUrl}/dpp/manufacturer/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getManufacturerDetailsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getManufacturerDetailsFailure(err.message));
      });
  };
};

const getProductVariantRequest = () => {
  return {
    type: "GET_PRODUCT_VARIANT_REQUEST",
  };
};

const getProductVariantSuccess = (payload) => {
  return {
    type: "GET_PRODUCT_VARIANT_SUCCESS",
    payload: payload,
  };
};

const getProductVariantFailure = (error) => {
  return {
    type: "GET_PRODUCT_VARIANT_FAILURE",
    payload: error,
  };
};

const getProductVariant = (itemId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getProductVariantRequest());
    let url = `${baseUrl}/dpp/product_variant/get_one?itemId=${itemId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getProductVariantSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getProductVariantFailure(err.message));
      });
  };
};


const createProductSpecRequest = () => {
  return {
    type: CREATE_PRODUCT_SPEC_REQUEST,
  };
};

const createProductSpecSuccess = (payload) => {
  return {
    type: CREATE_PRODUCT_SPEC_SUCCESS,
    payload: payload,
  };
};

const createProductSpecFailure = (error) => {
  return {
    type: CREATE_PRODUCT_SPEC_FAILURE,
    payload: error,
  };
};

const createProductSpec = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createProductSpecRequest());

    let url = `${baseUrl}/dpp/product_specifications/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createProductSpecSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createProductSpecFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getProductSpecificationRequest = () => {
  return {
    type: GET_PRODUCT_SPECIFICATION_REQUEST,
  };
};

const getProductSpecificationSuccess = (payload) => {
  return {
    type: GET_PRODUCT_SPECIFICATION_SUCCESS,
    payload: payload,
  };
};

const getProductSpecificationFailure = (error) => {
  return {
    type: GET_PRODUCT_SPECIFICATION_FAILURE,
    payload: error,
  };
};

const getProductSpecification = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getProductSpecificationRequest());

    let url = `${baseUrl}/dpp/product_specifications/get_dpp?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getProductSpecificationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getProductSpecificationFailure(err.message));
      });
  };
};


const uploadCsvForProductPassportChildRequest = () => ({
  type: UPLOADCSV_PRODUCT_PASSPORT_CHILD_REQUEST,
});

const uploadCsvForProductPassportChildSuccess = (payload) => ({
  type: UPLOADCSV_PRODUCT_PASSPORT_CHILD_SUCCESS,
  payload: payload,
});

const uploadCsvForProductPassportChildFailure = (error) => ({
  type: UPLOADCSV_PRODUCT_PASSPORT_CHILD_FAILURE,
  payload: error,
});

const uploadCsvForProductPassportChild = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForProductPassportChildRequest());
    let url = `${baseUrlFileUploadTemp}/dpp/product_passport_child/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForProductPassportChildSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForProductPassportChildFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  getPassPort,
  deletePassport,
  createPassPort,
  editPassport,
  getDppIds,
  getRmTraceability,
  getFgOperation,
  createRm,
  deleteRm,
  editRM,
  deletefG,
  createFG,
  editFg,
  getUsersForFG,
  getViewDataByDppId,
  getManufacturerDetails,
  getProductVariant,
  getIndustryType,
  getSupplierType,
  //  getDocumentTypeWithPagination
  //  , createDocumentType
  createProductSpec,
  getProductSpecification,
  uploadCsvForProductPassportChild,
};
